<template>
  <ul class="m-0 p-0 list-none">
    <slot />
  </ul>
</template>
